// noinspection JSUnusedGlobalSymbols
// File auto-generated on: 2025-06-03T15:14:56.939Z

import {
    PutAuthCurrentPasswordApiResponse,
    PutAuthCurrentPasswordApiArg,
    PostAuthOauthSignInApiResponse,
    PostAuthOauthSignInApiArg,
    GetAuthOauthByProviderAndModeApiResponse,
    GetAuthOauthByProviderAndModeApiArg,
    GetAuthSessionApiResponse,
    GetAuthSessionApiArg,
    DeleteAuthSessionApiResponse,
    DeleteAuthSessionApiArg,
    DeleteAuthSessionBySessionIdApiResponse,
    DeleteAuthSessionBySessionIdApiArg,
    PostAuthSignInApiResponse,
    PostAuthSignInApiArg,
    DeleteAuthSignOutApiResponse,
    DeleteAuthSignOutApiArg,
    PostAuthSignUpApiResponse,
    PostAuthSignUpApiArg,
    GetAuthSignUpDataApiResponse,
    GetAuthSignUpDataApiArg,
    PostAuthVerifyApiResponse,
    PostAuthVerifyApiArg,
    PutAuthByUserIdPasswordApiResponse,
    PutAuthByUserIdPasswordApiArg
} from "~/api/authAPI.types";

import { baseAPI as api } from "~/api/baseAPI";
const injectedRtkApi = api.injectEndpoints({
    endpoints: (build) => ({
        putAuthCurrentPassword: build.mutation<
            PutAuthCurrentPasswordApiResponse,
            PutAuthCurrentPasswordApiArg
        >({
            query: (queryArg) => ({
                url: "/auth/current/password",
                method: "PUT",
                body: queryArg.formDataAuthPutCurrentPasswordRequest,
                params: {"logout-all": queryArg["logout-all"]},
            }),
            extraOptions: {
                security: {
                    api_key_header: [],
                    api_key: [],
                    "jwt-token": [],
                    "jwt-cookie": [],
                    jwt: [],
                },
            },
        }),
        postAuthOauthSignIn: build.mutation<
            PostAuthOauthSignInApiResponse,
            PostAuthOauthSignInApiArg
        >({
            query: (queryArg) => ({
                url: "/auth/oauth-sign-in",
                method: "POST",
                body: queryArg.authPostOAuthSignInRequest,
                cookies: {
                    "oauth-provider-name": queryArg["oauth-provider-name"],
                    "oauth-email": queryArg["oauth-email"],
                    "oauth-provider-token": queryArg["oauth-provider-token"],
                },
            }),
        }),
        getAuthOauthByProviderAndMode: build.query<
            GetAuthOauthByProviderAndModeApiResponse,
            GetAuthOauthByProviderAndModeApiArg
        >({
            query: (queryArg) => ({
                url: `/auth/oauth/${queryArg.provider}/${queryArg.mode}`,
                cookies: {
                    "no-redirect": queryArg["cookie_no-redirect"],
                    "request-id": queryArg["request-id"],
                },
                params: {
                    "no-redirect": queryArg["query_no-redirect"],
                    code: queryArg.code,
                    state: queryArg.state,
                    error: queryArg.error,
                    host: queryArg.host,
                    "ret-url": queryArg["ret-url"],
                },
            }),
        }),
        getAuthSession: build.query<
            GetAuthSessionApiResponse,
            GetAuthSessionApiArg
        >({
            query: () => ({ url: "/auth/session" }),
            extraOptions: {
                security: {
                    api_key_header: [],
                    api_key: [],
                    "jwt-token": [],
                    "jwt-cookie": [],
                    jwt: [],
                },
            },
        }),
        deleteAuthSession: build.mutation<
            DeleteAuthSessionApiResponse,
            DeleteAuthSessionApiArg
        >({
            query: () => ({ url: "/auth/session", method: "DELETE" }),
            extraOptions: {
                security: {
                    api_key_header: [],
                    api_key: [],
                    "jwt-token": [],
                    "jwt-cookie": [],
                    jwt: [],
                },
            },
        }),
        deleteAuthSessionBySessionId: build.mutation<
            DeleteAuthSessionBySessionIdApiResponse,
            DeleteAuthSessionBySessionIdApiArg
        >({
            query: (queryArg) => ({
                url: `/auth/session/${queryArg}`,
                method: "DELETE",
            }),
            extraOptions: {
                security: {
                    api_key_header: [],
                    api_key: [],
                    "jwt-token": [],
                    "jwt-cookie": [],
                    jwt: [],
                },
            },
        }),
        postAuthSignIn: build.mutation<
            PostAuthSignInApiResponse,
            PostAuthSignInApiArg
        >({
            query: (queryArg) => ({
                url: "/auth/sign-in",
                method: "POST",
                body: queryArg,
            }),
        }),
        deleteAuthSignOut: build.mutation<
            DeleteAuthSignOutApiResponse,
            DeleteAuthSignOutApiArg
        >({
            query: (queryArg) => ({
                url: "/auth/sign-out",
                method: "DELETE",
                params: {
                    "logout-all": queryArg["logout-all"],
                    "ret-url": queryArg["ret-url"],
                },
            }),
            extraOptions: {
                security: {
                    api_key_header: [],
                    api_key: [],
                    "jwt-token": [],
                    "jwt-cookie": [],
                    jwt: [],
                },
            },
        }),
        postAuthSignUp: build.mutation<
            PostAuthSignUpApiResponse,
            PostAuthSignUpApiArg
        >({
            query: (queryArg) => ({
                url: "/auth/sign-up",
                method: "POST",
                body: queryArg.authPostSignUpRequest,
                headers: {"X-Recaptcha-Token": queryArg["X-Recaptcha-Token"]},
            }),
        }),
        getAuthSignUpData: build.query<
            GetAuthSignUpDataApiResponse,
            GetAuthSignUpDataApiArg
        >({query: () => ({ url: "/auth/sign-up-data" })}),
        postAuthVerify: build.mutation<
            PostAuthVerifyApiResponse,
            PostAuthVerifyApiArg
        >({
            query: (queryArg) => ({
                url: "/auth/verify",
                method: "POST",
                body: queryArg.authPostVerifyRequest,
                headers: {"X-Recaptcha-Token": queryArg["X-Recaptcha-Token"]},
            }),
        }),
        putAuthByUserIdPassword: build.mutation<
            PutAuthByUserIdPasswordApiResponse,
            PutAuthByUserIdPasswordApiArg
        >({
            query: (queryArg) => ({
                url: `/auth/${queryArg["user-id"]}/password`,
                method: "PUT",
                body: queryArg.formDataAuthPutUserPasswordRequest,
                params: {"logout-all": queryArg["logout-all"]},
            }),
            extraOptions: {
                security: {
                    api_key_header: [],
                    api_key: [],
                    "jwt-token": [],
                    "jwt-cookie": [],
                    jwt: [],
                },
            },
        }),
    }),
    overrideExisting: false,
});
export { injectedRtkApi as authAPI };
export const {
    usePutAuthCurrentPasswordMutation,
    usePostAuthOauthSignInMutation,
    useGetAuthOauthByProviderAndModeQuery,
    useLazyGetAuthOauthByProviderAndModeQuery,
    useGetAuthSessionQuery,
    useLazyGetAuthSessionQuery,
    useDeleteAuthSessionMutation,
    useDeleteAuthSessionBySessionIdMutation,
    usePostAuthSignInMutation,
    useDeleteAuthSignOutMutation,
    usePostAuthSignUpMutation,
    useGetAuthSignUpDataQuery,
    useLazyGetAuthSignUpDataQuery,
    usePostAuthVerifyMutation,
    usePutAuthByUserIdPasswordMutation,
} = injectedRtkApi;
